import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLang } from "@/App";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
    const { setUser, applyRemoteState } = useLang();
    const navigate = useNavigate();
    const hasProcessed = useRef(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
        if (!sessionId) {
            navigate("/", { replace: true });
            return;
        }
        (async () => {
            try {
                const res = await fetch(`${API}/auth/session`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify({ session_id: sessionId }),
                });
                if (!res.ok) throw new Error("auth failed");
                const user = await res.json();
                setUser(user);
                const stateRes = await fetch(`${API}/user/state`, { credentials: "include" });
                if (stateRes.ok) {
                    const state = await stateRes.json();
                    // applyRemoteState reloads the page itself when it adopts a remote chat session
                    if (applyRemoteState(state)) return;
                }
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/settings", { replace: true });
            } catch {
                setError(true);
                setTimeout(() => navigate("/settings", { replace: true }), 1800);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="fixed inset-0 z-[90] bg-[#080a12] grid place-items-center" data-testid="auth-callback">
            <div className="flex flex-col items-center gap-4">
                <div className="w-10 h-10 rounded-full border-2 border-[#d7ff35] border-t-transparent animate-spin" />
                <span className="font-mono2 text-[10px] tracking-[0.3em] text-slate-400">
                    {error ? "AUTH ERROR — REDIRECTING…" : "NEURAL LINK // CONNECTING…"}
                </span>
            </div>
        </div>
    );
}
